module.exports = __webpack_public_path__ + "img/comp-24.14d99070.png";